import { gql } from '@apollo/client';

export const MUTATION_INSERT_USER_TO_PATHOLOGY = gql`
  mutation MUTATION_INSERT_USER_TO_PATHOLOGY($userToPatology: [userToPatology_insert_input!]!) {
    insert_userToPatology(objects: $userToPatology) {
      returning {
        date
        id
        typePatology
        userId
        typePatologyVal {
          name
          value
        }
      }
    }
  }
`


export const MUTATION_DELETE_USER_TO_PATHOLOGY_BY_IDS = gql`
  mutation MUTATION_DELETE_USER_TO_PATHOLOGY_BY_IDS($userToPatologyIds: [uuid!]!) {
    delete_userToPatology(where: {id: {_in: $userToPatologyIds}}) {
      returning {
        date
        id
        typePatology
        userId
        typePatologyVal {
          name
          value
        }
      }
    }
  }
`